import { EyeOutlined } from '@ant-design/icons'
import { Icon } from '@iconify/react'
import { Tooltip } from 'antd'
import React, { FunctionComponent } from 'react'

import { SubjectFeature } from '../../../common/subjectTypes'
import { useAppSelector } from '../../../redux/hooks'
import { MunicipalOfficeIndicator } from '../MunicipalOfficeIndicator/MunicipalOfficeIndicator'

export interface SubjectSearchResultTableActionProps {
  record: SubjectFeature
}

export const SubjectSearchResultTableAction: FunctionComponent<SubjectSearchResultTableActionProps> =
  ({ record }) => {
    const open = useAppSelector(
      state => state.map.popupData?.properties?.id === record.properties.id
    )
    if (!record.properties.adresniMistoKod || !record.properties.ulice) {
      return (
        <Tooltip
          title="Tato adresa není zakreslena v mapě"
          className="flex items-center text-gray-400 cursor-help"
          trigger="click"
        >
          <div>
            <Icon className="block h-5" icon="lucide:map-pin-off" />
          </div>
        </Tooltip>
      )
    }
    if (open) {
      return (
        <div className="flex items-center">
          <div
            title="Náhled adresy je otevřen v mapě"
            className="flex items-center"
          >
            <EyeOutlined />
          </div>
          <MunicipalOfficeIndicator
            addressId={record.properties.adresniMistoKod}
            className="ml-2 -mt-px text-gray-400"
          />
        </div>
      )
    }
    return (
      <div className="flex items-center">
        <div
          title="Kliknutím otevřete náhled v mapě"
          className="flex items-center"
        >
          <Icon className="block h-5" icon="clarity:picture-outline-badged" />
        </div>
        <MunicipalOfficeIndicator
          addressId={record.properties.adresniMistoKod}
          className="ml-2 -mt-px text-gray-400"
        />
      </div>
    )
  }
